import React, { Fragment } from 'react'
import { RiskExplanation } from './RiskExplanation'
import { RiskBreakdown } from './RiskBreakdown'
import { Overlay } from '../../components/Overlay'
import { Button } from '../../components/Button'
import RiskQuestionnaireWidget from '../../risk_profile/RiskProfileWidget'
import { updateDetailedRiskUsingHandler } from './RiskHelper'

export const DetailedRisk = (props) => {
  return (
    props.takingQuestionnaire
      ? <RiskQuestionnaire
        {...props}
        onRetakeComplete={(formattedAssessmentResults) => {
          updateDetailedRiskUsingHandler(
            props.updateRiskHandler,
            props.riskProfile,
            formattedAssessmentResults,
            props.isWealthManager,
            props.crudActions,
            props.saygScenariosEnabled
          )
          props.setTakingQuestionnaire(false)
        }} />
      : <DetailedRiskDashboard
        {...props}
        onRetakeClick={() => props.setTakingQuestionnaire(true)}
      />
  )
}

const DetailedRiskDashboard = (props) =>
  <div className='risk-profile'>
    <RiskExplanation key='risk-explanation' {...props} />
    <RiskBreakdown key='risk-breakdown' {...props} />
    {
      props.riskProfile.selected === 'simple' &&
      <RiskOverlay {...props} />
    }
  </div>

const RiskOverlay = (props) =>
  <Overlay>
    <div className='ui-card text-box'>
      <h2 className='bold'>
        Retake the questionnaire
      </h2>
      <p>
          You are currently using <b>simple risk</b> as your risk rating which overrides your detailed risk profile. Retaking the risk questions will help us determine your risk <b>tolerance</b> and create a detailed risk profile.</p>
      <div className='retake-button'>
        <Button
          primary
          onClick={() => props.onRetakeClick()}
          data-tracking='true' data-event-name='Scenario planning: Retake risk questions'>{ `RETAKE RISK QUESTIONS` }</Button>
      </div>
    </div>
  </Overlay>

const RiskQuestionnaire = ({ tenant, onRetakeComplete }) =>
  <div className='risk-profile__questionnaire'>
    <RiskQuestionnaireWidget
      scenarioPlanningResultsHandler={(formattedAssessmentResults) => onRetakeComplete(formattedAssessmentResults)}
      tenant={tenant} />
  </div>
